import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import logo from '../../logos/storage-sprint.png';

const CustomerWelcomePage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/login');
        }, 7000);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 py-12">
            <Helmet>
                <title>Welcome to Storage Sprint</title>
            </Helmet>

            <div className="max-w-md w-full bg-white rounded-xl shadow-md p-8 text-center">
                <img
                    src={logo}
                    alt="Storage Sprint Logo"
                    className="mx-auto mb-6 w-24 h-auto"
                />

                <h1 className="text-2xl font-bold text-gray-800 mb-4">
                    Welcome,
                    <span className="text-yellow-500"> new Storage Sprint customer!</span>
                </h1>

                <p className="text-gray-600 mb-6">
                    We’re thrilled you chose Storage Sprint. Our team is excited to help
                    you have a seamless delivery experience.
                </p>
                <p className="text-gray-600 mb-8">
                    Thank you for trusting us. We look forward to making your journey with
                    Storage Sprint exceptional.
                </p>

                <p className="italic text-gray-500 mb-6">
                    Redirecting you to your login shortly...
                </p>
            </div>
        </div>
    );
};

export default CustomerWelcomePage;
